<template>
    <div>
        <a
            href="#"
            class="btn btn-white-outline-blue wishlist_bottom"
            @click.prevent="addToWishList"
            :disabled="isDisabled"
            :class="wishListClass"
            >{{ buttonlabel }}</a>
        <div class="modal-wishlist" v-show="showModal">
            <h4 v-html="added_to_wishlist"></h4>
            <a href="wishlist" class="btn btn-hover btn-primary btn-cart">{{ label_view_wishlist }}</a>
            <a class="close btn btn-hover btn-primary btn-wishlist" @click="closeModal()">{{ label_continue_shopping }}</a>
        </div>
        <div class="modal-bg" v-show="showModal"></div>
    </div>
</template>

<script>
export default {
    name: "wishlist-zwifloc",
    props: {
        data: {},
        getPackageComponents_url: {},
        add_to_wishlist: {
            type: String,
            default: "Add to Wish List"
        },
        added_to_wishlist: {
            type: String,
            default: "Added to Wish List"
        },
        label_view_wishlist: {
            type: String,
            default: "View Wish List"
        },
        label_continue_shopping: {
            type: String,
            default: "Continue Shopping"
        },
        ga_tracking_category: {
            type: String,
            default: "WishList"
        },
        ga_tracking_action: {
            type: String,
            default: "Click"
        },
        ga_tracking_label: {
            type: String,
            default: "Button"
        },
        enable_b2c: {},
        enable_b2b: {},
    },
    data() {
        return {
            cartmode: false,
            isDisabled: false,
            added: false,
            showModal: false
        };
    },
    mounted() {
        var enables = new Object();
        enables["enable_b2b"] = this.enable_b2b;
        enables["enable_b2c"] = this.enable_b2c;
        if (this.data.netSuiteId) {
            this.$store
                .dispatch("auth/isCartMode", enables)
                .then(data => {
                this.cartmode = data;
            })
            .catch(error => {});
        }
    },
    methods: {
        addToWishList() {
            this.showModal = true;
            for(let i= 0; i<this.data[0].quantity; i++){
                this.$store.commit("wishlist/addItem", this.data[0].stockCode);
            }
            this.added = true;
            ga('send', 'event', this.ga_tracking_category, this.ga_tracking_action, this.ga_tracking_label);
            gtag('event',  this.ga_tracking_category, {'category': this.ga_tracking_category, 'action':this.ga_tracking_action +  ' Spec', value:this.ga_tracking_label});
        },
        closeModal() {
            this.showModal = false;
        }
    },
    computed: {
        HasDealer() {
            return this.dealer_set == "1" ? true : false;
        },
        getPackageComponentsUrl() {
            return "/api/getPackageComponents/" + this.data.productId;
        },
        buttonlabel() {
            return !this.added ? this.add_to_wishlist : this.added_to_wishlist;
        },
        wishListClass() {
            return (this.cartmode && !this.HasDealer) ? 'btn-wishlist' : 'btn-wishlist-only';
        }
    }
};
</script>

<style scoped>
.wishlist_bottom{
    width: 100%;
    text-align: center;
}
.modal-wishlist {
    background: #FFF;
    width: 255px;
    height: auto;
    text-align: center;
    position: fixed;
    top: 50%;
    margin-top: -80px;
    left: 50%;
    margin-left: -128px;
    line-height: 25px;
    z-index: 100001;
    padding: 15px;
    border: 1px solid #b65b00;
}
.modal-wishlist h4 {
    font-size: 1.4rem;
}
.modal-wishlist .btn {
    font-size: .9rem;
}
@media (min-width: 768px) and (max-width: 1200px) {
    .modal-wishlist {
        width: 210px;
        margin-top: -115px;
        margin-left: -105px;
    }
    .modal-wishlist h4 {
        font-size: 1.1rem;
    }
    .modal-wishlist .btn {
        padding: 12px 10px 10px;
    }
}

.modal-wishlist .close,
.modal-wishlist .close:hover {
    cursor: pointer;
}
.modal-bg {
    background-color: rgba(0,0,0, .2);
    opacity: .2;
    filter: alpha(opacity=20);
    zoom: 1;

    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100000;
}

.btn-wishlist-outlined {
    background-color: white;
    color: #B65B00;
    border: 1px solid #B65B00;
}

.btn-wishlist-outlined:hover {
    color: white;
}

.btn-hover {
  position: relative;
  transition: all 0.15s;
  transform: perspective(1px) translateZ(0);
  z-index: 1;
}
.btn-hover::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.btn-hover:after {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #B65B00;
  transform: scaleX(0);
  transform-origin: 0 50%;
  transition: transform 0.15s ease-out;
}
.btn-hover:hover:after {
  transform: scaleX(1);
}
.btn-hover:disabled {
  transform: none;
}
.btn-hover:disabled:hover:after {
  transform: none;
}


</style>
